import { createContext } from '@lit/context';
import { Curator } from '../../@types/wishlist.js';
import { WishlistRouter } from '../../templates/components/wishlist-app/wishlist-router.js';

export interface WishlistAppConfig {
  appUrl: string;
  favoritesEndpoint: string;
  collectionEndpoint: string;
  curatedCollectionEndpoint: string;
  looksEndpoint: string;
  favoritesEndpoints: string[];
  curatedCollectionEndpoints: string[];
  collectionEndpoints: string[];
  loginEndpointWithFavoritesReferrer: string;
  loginEndpointWithFavoritesEventLayerOpenReferrer: string;
  loginEndpointWithCollectionReferrer: string;
  loginEndpointWithCuratedCollectionReferrer: string;
  curatedCollectionApiEndpoint: string;
  curatedCollectionApiToModifyBocaEndpoint: string;
  productEndpoint: string;
  mixAndMatchEndpoint: string;
  productLineEndpoint: string;
  capsuleEndpoint: string;
  eventsEndpoint: string;
  eventsSeenEndpoint: string;
  eventsAppLayerEndpoint: string;
  cartEndpoint: string;
  isAppNativeBottomSheetEnabled: boolean;
  surveyCollectorId: string;
  surveyEnabled: boolean;
  showChristmasBear: boolean;
  isCurator: boolean;
  hasCuratedCollections: boolean;
  isDynamicFilteringEnabled: boolean;
  vtoEnabled: boolean;
  vtoTtlMillis: number;
  brandsEnabled: boolean;
  brandsEndpoint: string;
  brandsEndpoints: string[];
  brandsApiEndpoint: string;
  brandRecommendationsApiEndpoint: string;
  brandRecommendationsEnabled: boolean;
  brandsUrl: string;
  featureApiEndpoint: string;
  showBrandsTabIndicator: boolean;
  showVtoModelswitchIndicator: boolean;
  vtoCuratedAdDismissed: boolean;
  recoVspEnabled: boolean;
  aiMarkingEnabled: boolean;
  legacyNotifyMeButtonEnabled: boolean;
  wishlistHeartIcon: boolean;
  mainCurator?: Curator;
}

export const wishlistAppConfigContext = createContext<WishlistAppConfig>('wishlistAppConfigContext');
export const wishlistRouterContext = createContext<WishlistRouter>('wishlistRouterContext');
